import React, { useState } from "react"

import Grid from "@material-ui/core/Grid"
import CircularProgress from "@material-ui/core/CircularProgress"

export const LoadingContext = React.createContext(false)

const loading = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
}

export const LoadingHOC = ({ children }) => {
  const [loadingContextData, setLoadingContextData] = useState(false)

  return (
    <LoadingContext.Provider
      value={{ loading: loadingContextData, setLoading: setLoadingContextData }}
    >
      {children}
      {loadingContextData && (
        <Grid style={loading} container justifyContent={"center"}>
          <CircularProgress />
        </Grid>
      )}
    </LoadingContext.Provider>
  )
}
